import Bold from './Bold.vue';
import BulletList from './BulletList.vue';
import HorizontalRule from './HorizontalRule.vue';
import Italic from './Italic.vue';
import Link from './Link.vue';
import OrderedList from './OrderedList.vue';
import Redo from './Redo.vue';
import Strike from './Strike.vue';
import Underline from './Underline.vue';
import Undo from './Undo.vue';

import Divider from './Divider.vue';

export default {
	Bold,
	BulletList,
	Divider,
	HorizontalRule,
	Italic,
	Link,
	OrderedList,
	Redo,
	Strike,
	Underline,
	Undo
};